import { createAction, props } from '@ngrx/store';
import { Cart, Customer, ShopifyError } from '../../models';

export const LoadCart = createAction('[Cart] Load Cart');
export const LoadCartSuccess = createAction('[Cart] Load Cart Success', props<{ cart: any }>());
export const LoadCartFail = createAction('[Cart] Load Cart Fail', props<{ error: ShopifyError[] }>());

export const InitCart = createAction('[Cart] Init Cart');
export const InitCartSuccess = createAction('[Cart] Init Cart Success', props<{ cart: any }>());
export const InitCartFail = createAction('[Cart] Init Cart Fail', props<{ error: ShopifyError[] }>());

export const AddToCart = createAction('[Cart] Add To Cart', props<{ lines: { merchandiseId: string; quantity: number }[] }>());
export const AddToCartSuccess = createAction('[Cart] Add To Cart Success', props<{ cart: any }>());
export const AddToCartFail = createAction('[Cart] Add To Cart Fail', props<{ error: ShopifyError[] }>());

export const UpdateCartLine = createAction('[Cart] Update Cart Line', props<{ lineId: string; quantity: number }>());
export const UpdateCartLineSuccess = createAction('[Cart] Update Cart Line Success', props<{ cart: any; lineId: string }>());
export const UpdateCartLineFail = createAction('[Cart] Update Cart Line Fail', props<{ error: ShopifyError[] }>());

export const DeleteCartLine = createAction('[Cart] Delete Cart Line', props<{ lineId: string }>());
export const DeleteCartLineSuccess = createAction('[Cart] Delete Cart Line Success', props<{ cart: any; lineId: string }>());
export const DeleteCartLineFail = createAction('[Cart] Delete Cart Line Fail', props<{ error: any }>());

export const UpdateCartBuyerIdentity = createAction('[Cart] Update Cart Buyer Identity', props<{ token: string; email?: string }>());
export const UpdateCartBuyerIdentitySuccess = createAction('[Cart] Update Cart Buyer Identity Success', props<{ cart: any }>());
export const UpdateCartBuyerIdentityFail = createAction('[Cart] Update Cart Buyer Identity Fail', props<{ error: ShopifyError[] }>());

export const ClearCart = createAction('[Cart] Clear Cart');
export const ClearCartSuccess = createAction('[Cart] Clear Cart Success');
export const ClearCartFail = createAction('[Cart] Clear Cart Fail', props<{ error: ShopifyError[] }>());

export const BuyNow = createAction('[Cart] Buy now', props<{ lines: { variantId: string; quantity: number }[] }>());
export const BuyNowSuccess = createAction('[Cart] Buy now Success', props<{ checkout: any }>());
export const BuyNowFail = createAction('[Cart] Buy now Fail', props<{ error: ShopifyError[] }>());

export const UpdateDiscounts = createAction('[Cart] Update discount code', props<{ discountCodes: string[]; redirect?: any[] }>());
export const UpdateDiscountsSuccess = createAction('[Cart] Update discount Success', props<{ cart: Cart; redirect?: any[] }>());
export const UpdateDiscountsFail = createAction('[Cart] Update discount Fail', props<{ error: ShopifyError[]; redirect?: any[] }>());

export const UpdateCartNote = createAction('[Cart] Update Cart Note', props<{ note: string }>());
export const UpdateCartNoteSuccess = createAction('[Cart] Update Cart Note Success', props<{ cart: any }>());
export const UpdateCartNoteFail = createAction('[Cart] Update Cart Note Fail', props<{ error: ShopifyError[] }>());

export const StartCheckout = createAction('[Cart] Start checkout');
